export const BANNER_ROTATIONS = [
  // Phase 1: Ineffa / Citlali
  {
    endDate: "2025-08-19T16:59:59Z",
    character1: {
      fiveStar: "Ineffa",
      element: "Electro",
      bannerNameKey: "banner_ineffa",
      fourStars: ["Fischl", "Sethos", "Xingqiu"],
    },
    character2: {
      fiveStar: "Citlali",
      element: "Cryo",
      bannerNameKey: "banner_citlali",
      fourStars: ["Fischl", "Sethos", "Xingqiu"],
    },
    weapon: {
      fiveStars: ["Starcaller's Watch", "Fractured Halo"],
      fourStars: [
        "Sturdy Bone",
        "Mountain-Bracing Bolt",
        "Sacrificial Greatsword",
        "Favonius Codex",
        "Favonius Warbow",
      ],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // Phase 2: Chasca / Mualani
  {
    endDate: "2025-09-09T13:59:59Z",
    character1: {
      fiveStar: "Mualani",
      element: "Hydro",
      bannerNameKey: "banner_mualani",
      fourStars: ["Ifa", "Ororon", "Bennett"],
    },
    character2: {
      fiveStar: "Chasca",
      element: "Anemo",
      bannerNameKey: "banner_chasca",
      fourStars: ["Ifa", "Ororon", "Bennett"],
    },
    weapon: {
      fiveStars: ["Surf's Up", "Astral Vulture's Crimson Plumage"],
      fourStars: [
        "Fruitful Hook",
        "Waveriding Whirl",
        "Flower-Wreathed Feathers",
        "Favonius Sword",
        "Favonius Lance",
      ],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // ★★★ NEU: LULL-PHASE (BANNER ENDE, VOR WARTUNG) ★★★
  {
    endDate: "2025-09-09T21:59:59Z", // Endet um 22:00 Uhr
    phaseType: "lull",
    // Die Banner-Daten können leer bleiben, da sie nicht angezeigt werden.
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // ★★★ NEU: SERVER-DOWN-PHASE (WARTUNG) ★★★
  {
    endDate: "2025-09-10T02:59:59Z", // Endet um 03:00 Uhr morgens
    phaseType: "server_down",
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // Phase 1 6.0: Lauma / Nahida
  {
    endDate: "2025-09-30T16:59:59Z",
    character1: {
      fiveStar: "Lauma",
      element: "Dendro",
      bannerNameKey: "banner_lauma",
      fourStars: ["Barbara", "Kuki Shinobu", "Kaveh"],
    },
    character2: {
      fiveStar: "Nahida",
      element: "Dendro",
      bannerNameKey: "banner_nahida",
      fourStars: ["Barbara", "Kuki Shinobu", "Kaveh"],
    },
    weapon: {
      fiveStars: ["Nightweaver's Looking Glass", "A Thousand Floating Dreams"],
      fourStars: [
        "The Flute",
        "Sacrificial Greatsword",
        "Dragon's Bane",
        "Sacrificial Fragments",
        "The Stringless",
      ],
    },
    chronicled: {
      region: "Sumeru",
      fiveStars: {
        characters: [
          "Dehya",
          "Alhaitham",
          "Wanderer",
          "Cyno",
          "Nilou",
          "Tighnari",
        ],
        weapons: [
          "Light of Foliar Incision",
          "Key of Khaj-Nisut",
          "Beacon of the Reed Sea",
          "Staff of the Scarlet Sands",
          "Tulaytullah's Remembrance",
          "Hunter's Path",
        ],
      },
      fourStars: {
        characters: [
          "Sethos",
          "Kaveh",
          "Faruzan",
          "Layla",
          "Candace",
          "Dori",
          "Collei",
        ],
        weapons: [
          "Xiphos' Moonlight",
          "Makhaira Aquamarine",
          "Wandering Evenstar",
        ],
      },
    },
  },
  // Phase 2 6.0: Flins / Yelan
  {
    endDate: "2025-10-21T13:59:59Z",
    character1: {
      fiveStar: "Flins",
      element: "Electro",
      bannerNameKey: "banner_flins",
      fourStars: ["Aino", "Sucrose", "Dori"],
    },
    character2: {
      fiveStar: "Yelan",
      element: "Hydro",
      bannerNameKey: "banner_yelan",
      fourStars: ["Aino", "Sucrose", "Dori"],
    },
    weapon: {
      fiveStars: ["Bloodsoaked Ruins", "Aqua Simulacra"],
      fourStars: [
        "Lion's Roar",
        "Favonius Greatsword",
        "Favonius Lance",
        "Favonius Codex",
        "Sacrificial Bow",
      ],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // ★★★ NEU: LULL-PHASE (BANNER ENDE, VOR WARTUNG) ★★★
  {
    endDate: "2025-10-21T21:59:59Z", // Endet um 00:00 Uhr mesz
    phaseType: "lull",
    // Die Banner-Daten können leer bleiben, da sie nicht angezeigt werden.
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // ★★★ NEU: SERVER-DOWN-PHASE (WARTUNG) ★★★
  {
    endDate: "2025-10-22T04:59:59Z", // Endet um 07:00 MESZ
    phaseType: "server_down",
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // Phase 1 6.1: Nefer / Furina
  {
    endDate: "2025-11-11T16:59:59Z",
    character1: {
      fiveStar: "Nefer",
      element: "Dendro",
      bannerNameKey: "banner_nefer",
      fourStars: ["Xingqiu", "Collei", "Yaoyao"],
    },
    character2: {
      fiveStar: "Furina",
      element: "Hydro",
      bannerNameKey: "banner_furina",
      fourStars: ["Xingqiu", "Collei", "Yaoyao"],
    },
    weapon: {
      fiveStars: ["Reliquary of Truth", "Splendor Of Tranquil Waters"],
      fourStars: [
        "Moonweaver's Dawn",
        "Sacrificer's Staff",
        "Dawning Frost",
        "The Bell",
        "Favonius Warbow",
      ],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // Phase 2 6.1: Arlecchino / Zhongli
  {
    endDate: "2025-12-02T13:59:59Z",
    character1: {
      fiveStar: "Arlecchino",
      element: "Pyro",
      bannerNameKey: "banner_arlecchino",
      fourStars: ["Lan Yan", "Yun Jin", "Rosaria"],
    },
    character2: {
      fiveStar: "Zhongli",
      element: "Geo",
      bannerNameKey: "banner_zhongli",
      fourStars: ["Lan Yan", "Yun Jin", "Rosaria"],
    },
    weapon: {
      fiveStars: ["Crimson Moon's Semblance", "Vortex Vanquisher"],
      fourStars: [
        "Dragon's Bane",
        "Sacrificial Fragments",
        "The Dockhand's Assistant",
        "Portable Power Saw",
        "Range Gauge",
      ],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // ★★★ NEU: LULL-PHASE (BANNER ENDE, VOR WARTUNG) ★★★
  {
    endDate: "2025-12-02T21:59:59Z", // Endet um 23:00 Uhr mez
    phaseType: "lull",
    // Die Banner-Daten können leer bleiben, da sie nicht angezeigt werden.
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // ★★★ NEU: SERVER-DOWN-PHASE (WARTUNG) ★★★
  {
    endDate: "2025-12-03T02:59:59Z", // Endet um 04:00 MEZ
    phaseType: "server_down",
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // Phase 1 6.2: Durin / Venti
  {
    endDate: "2025-12-23T16:59:59Z",
    character1: {
      fiveStar: "Durin",
      element: "Pyro",
      bannerNameKey: "banner_durin",
      fourStars: ["Jahoda", "Bennett", "Faruzan"],
    },
    character2: {
      fiveStar: "Venti",
      element: "Anemo",
      bannerNameKey: "banner_venti",
      fourStars: ["Jahoda", "Bennett", "Faruzan"],
    },
    weapon: {
      fiveStars: ["Athame Artis", "The Daybreak Chronicles"],
      fourStars: ["The Alley Flash", "Prospector's Drill", "Wine and Song", "Rainslasher", "The Stringless"],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // Phase 2 6.2: Xilonen / Varesa
  {
    endDate: "2026-01-13T13:59:59Z",
    character1: {
      fiveStar: "Varesa",
      element: "Electro",
      bannerNameKey: "banner_varesa",
      fourStars: ["Iansan", "Chevreuse", "Gaming"],
    },
    character2: {
      fiveStar: "Xilonen",
      element: "Geo",
      bannerNameKey: "banner_xilonen",
      fourStars: ["Iansan", "Chevreuse", "Gaming"],
    },
    weapon: {
      fiveStars: ["Vivid Notions", "Peak Patrol Song"],
      fourStars: ["Fruitful Hook", "Alley Hunter", "Favonius Sword", "Favonius Lance", "The Widsith"],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // ★★★ NEU: LULL-PHASE (BANNER ENDE, VOR WARTUNG) ★★★
  {
    endDate: "2026-01-13T21:59:59Z", // Endet um 23:00 Uhr mez
    phaseType: "lull",
    // Die Banner-Daten können leer bleiben, da sie nicht angezeigt werden.
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // ★★★ NEU: SERVER-DOWN-PHASE (WARTUNG) ★★★
  {
    endDate: "2026-01-14T02:59:59Z", // Endet um 04:00 MEZ
    phaseType: "server_down",
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // Phase 1 6.3: Columbina / Ineffa
  {
    endDate: "2026-02-03T16:59:59Z",
    character1: {
      fiveStar: "Columbina",
      element: "Hydro",
      bannerNameKey: "banner_columbina",
      fourStars: ["Sethos", "Fischl", "Ifa"],
    },
    character2: {
      fiveStar: "Ineffa",
      element: "Electro",
      bannerNameKey: "banner_ineffa",
      fourStars: ["Sethos", "Fischl", "Ifa"],
    },
    weapon: {
      fiveStars: ["Nocturne's Curtain Call", "Fractured Halo"],
      fourStars: ["Mountain-Bracing Bolt", "Waveriding Whirl", "Mitternachts Waltz", "The Flute", "Sacrificial Greatsword"],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // Phase 2 6.3: Zibai / Neuvillette
  {
    endDate: "2026-02-24T13:59:59Z",
    character1: {
      fiveStar: "Zibai",
      element: "Geo",
      bannerNameKey: "banner_zibai",
      fourStars: ["Illuga", "Aino", "Gorou"],
    },
    character2: {
      fiveStar: "Neuvillette",
      element: "Hydro",
      bannerNameKey: "banner_neuvillette",
      fourStars: ["Illuga", "Aino", "Gorou"],
    },
    weapon: {
      fiveStars: ["Lightbearing Moonshard", "Tome of the Eternal Flow"],
      fourStars: ["Xiphos' Moonlight", "Favonius Greatsword", "Dragon's Bane", "Eye of Perception", "Favonius Warbow"],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // ★★★ NEU: LULL-PHASE (BANNER ENDE, VOR WARTUNG) ★★★
  {
    endDate: "2026-02-24T21:59:59Z", // Endet um 23:00 Uhr mez
    phaseType: "lull",
    // Die Banner-Daten können leer bleiben, da sie nicht angezeigt werden.
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // ★★★ NEU: SERVER-DOWN-PHASE (WARTUNG) ★★★
  {
    endDate: "2026-02-25T02:59:59Z", // Endet um 04:00 MEZ
    phaseType: "server_down",
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // Phase 1 6.4: Varka / Flins
  {
    endDate: "2026-03-17T16:59:59Z",
    character1: {
      fiveStar: "Varka",
      element: "Anemo",
      bannerNameKey: "banner_varka",
      fourStars: ["Bennett", "Xiangling", "Sucrose"],
    },
    character2: {
      fiveStar: "Flins",
      element: "Electro",
      bannerNameKey: "banner_flins",
      fourStars: ["Bennett", "Xiangling", "Sucrose"],
    },
    weapon: {
      fiveStars: ["Gest of the Mighty Wolf", "Bloodsoaked Ruins"],
      fourStars: ["Sacrificer's Staff", "Favonius Sword", "Favonius Greatsword", "Sacrificial Fragments", "Sacrificial Bow"],
    },
    chronicled: {
      region: "Mondstadt",
      fiveStars: {
        characters: ["Eula", "Mona", "Albedo", "Klee", "Diluc", "Jean"],
        weapons: ["Song of Broken Pines", "Elegy for the End", "Skyward Blade", "Aquila Favonia", "Wolf's Gravestone", "Skyward Pride", "Skyward Spine", "Lost Prayer to the Sacred Winds", "Skyward Atlas", "Skyward Harp"],
      },
      fourStars: {
        characters: ["Dahlia", "Mika", "Rosaria", "Sucrose", "Diona", "Noelle", "Bennett", "Fischl", "Amber", "Razor", "Kaeya", "Barbara", "Lisa"],
        weapons: ["The Alley Flash", "Wine and Song", "Mitternachts Waltz", "Alley Hunter"],
      },
    },
  },
  // Phase 2 6.4: Skirk / Escoffier
  {
    endDate: "2026-04-07T13:59:59Z",
    character1: {
      fiveStar: "Skirk",
      element: "Cryo",
      bannerNameKey: "banner_skirk",
      fourStars: ["Dahlia", "Candace", "Charlotte"],
    },
    character2: {
      fiveStar: "Escoffier",
      element: "Cryo",
      bannerNameKey: "banner_escoffier",
      fourStars: ["Dahlia", "Candace", "Charlotte"],
    },
    weapon: {
      fiveStars: ["Azurelight", "Symphonist of Scents"],
      fourStars: ["The Flute", "The Bell", "Favonius Lance", "Favonius Codex", "Rust"],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // ★★★ NEU: LULL-PHASE (BANNER ENDE, VOR WARTUNG) ★★★
  {
    endDate: "2026-04-07T21:59:59Z", // Endet um 00:00 Uhr mez
    phaseType: "lull",
    // Die Banner-Daten können leer bleiben, da sie nicht angezeigt werden.
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // ★★★ NEU: SERVER-DOWN-PHASE (WARTUNG) ★★★
  {
    endDate: "2026-04-08T02:59:59Z", // Endet um 05:00 MESZ
    phaseType: "server_down",
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // Phase 1 6.5: Linnea / Chasca
  {
    endDate: "2026-04-28T16:59:59Z",
    character1: {
      fiveStar: "Linnea",
      element: "Geo",
      bannerNameKey: "banner_linnea",
      fourStars: ["Illuga", "Aino", "Noelle"],
    },
    character2: {
      fiveStar: "Chasca",
      element: "Anemo",
      bannerNameKey: "banner_chasca",
      fourStars: ["Illuga", "Aino", "Noelle"],
    },
    weapon: {
      fiveStars: ["Golden Frostbound Oath", "Astral Vulture's Crimson Plumage"],
      fourStars: ["Flower-Wreathed Feathers", "Lion's Roar", "Sacrificial Greatsword", "Dragon's Bane", "Eye of Perception"],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // Phase 2 6.5: Nefer / Lauma
  {
    character1: {
      fiveStar: "Lauma",
      element: "Dendro",
      bannerNameKey: "banner_lauma",
      fourStars: ["Xingqiu", "Kirara", "Jahoda"],
    },
    endDate: "2026-05-19T14:59:59Z",
    character2: {
      fiveStar: "Nefer",
      element: "Dendro",
      bannerNameKey: "banner_nefer",
      fourStars: ["Xingqiu", "Kirara", "Jahoda"],
    },
    weapon: {
      fiveStars: ["Reliquary of Truth", "Nightweaver's Looking Glass"],
      fourStars: ["Dawning Frost", "Sacrificial Sword", "Rainslasher", "Favonius Lance", "Favonius Warbow"],
    },
    chronicled: {
      region: "Fontaine",
      fiveStars: {
        characters: ["Emilie", "Clorinde", "Navia", "Sigewinne", "Lyney"],
        weapons: ["Lumidouce Elegy", "Absolution", "Verdict", "Silvershower Heartstrings", "The First Great Magic"],
      },
      fourStars: {
        characters: ["Chevreuse", "Charlotte", "Freminet", "Lynette"],
        weapons: ["The Dockhand's Assistant", "Portable Power Saw", "Prospector's Drill", "Range Gauge"],
      },
    },
  },
  // ★★★ NEU: LULL-PHASE (BANNER ENDE, VOR WARTUNG) ★★★
  {
    endDate: "2026-05-19T21:59:59Z", // Endet um 00:00 Uhr mez
    phaseType: "lull",
    // Die Banner-Daten können leer bleiben, da sie nicht angezeigt werden.
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // ★★★ NEU: SERVER-DOWN-PHASE (WARTUNG) ★★★
  {
    endDate: "2026-05-20T02:59:59Z", // Endet um 05:00 MESZ
    phaseType: "server_down",
    character1: {},
    character2: {},
    weapon: {},
    chronicled: {},
  },
  // Phase 1 6.6: Nicole / Durin
  {
    endDate: "2026-06-09T16:59:59Z",
    character1: {
      fiveStar: "Nicole",
      element: "Pyro",
      bannerNameKey: "banner_nicole",
      fourStars: ["Illuga", "Aino", "Noelle"],
    },
    character2: {
      fiveStar: "Durin",
      element: "Pyro",
      bannerNameKey: "banner_durin",
      fourStars: ["", "", ""],
    },
    weapon: {
      fiveStars: ["Seven Edicts of Dust and Light", "Athame Artis"],
      fourStars: ["", "", "", "", ""],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
  // Phase 2 6.6: Lohen / Mauvika
  {
    endDate: "2026-06-30T14:59:59Z",
    character1: {
      fiveStar: "Lohen",
      element: "Cryo",
      bannerNameKey: "banner_lohen",
      fourStars: ["Prune", "", ""],
    },
    character2: {
      fiveStar: "Mauvika",
      element: "Pyro",
      bannerNameKey: "banner_mauvika",
      fourStars: ["Prune", "", ""],
    },
    weapon: {
      fiveStars: ["Disaster and Remorse", "A Thousand Blazing Suns"],
      fourStars: ["", "", "", "", ""],
    },
    chronicled: {
      region: "",
      fiveStars: {
        characters: [""],
        weapons: [""],
      },
      fourStars: {
        characters: [""],
        weapons: [""],
      },
    },
  },
];
